import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import React, { useRef, useState, useEffect } from 'react';
import { PropTypes, describe } from 'react-desc';
import useFocusGroupItem from '@elliemae/ds-shared/FocusGroup/useFocusGroupItem';
import DSTooltip from '@elliemae/ds-tooltip';
import { Pill } from './Pill.js';
import '@babel/runtime/helpers/esm/extends';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import '@babel/runtime/helpers/esm/defineProperty';
import '@elliemae/ds-classnames';

function OverflowPill(_ref) {
  var _ref$containerProps = _ref.containerProps,
      containerProps = _ref$containerProps === void 0 ? {} : _ref$containerProps,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? '' : _ref$label,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options;
  var ref = useRef(null);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      tooltipIsOpen = _useState2[0],
      setTooltipIsOpen = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      tooltipText = _useState4[0],
      setTooltipText = _useState4[1];

  useEffect(function () {
    var text = '';
    options.forEach(function (option) {
      if (!tooltipText || option === options[0]) {
        text = "".concat(option.label);
      } else {
        text = text.concat(", ".concat(option.label));
      }
    });
    setTooltipText(text);
  }, [options]);
  useFocusGroupItem(ref);
  return /*#__PURE__*/React.createElement(DSTooltip, {
    isOpen: tooltipIsOpen,
    title: tooltipText,
    zIndex: 11,
    triggerComponent: /*#__PURE__*/React.createElement(Pill, {
      className: "overflow-pill",
      containerProps: containerProps,
      innerRef: ref,
      label: label,
      tabIndex: -1,
      onMouseEnter: function onMouseEnter() {
        return setTooltipIsOpen(true);
      },
      onMouseLeave: function onMouseLeave() {
        return setTooltipIsOpen(false);
      }
    })
  });
}

var props = {
  /** props to inject to pill wrapper */
  containerProps: PropTypes.object.description('props to inject to pill wrapper'),

  /** pill text label */
  label: PropTypes.string.isRequired.description('pill text label'),

  /** overflow pills options */
  options: PropTypes.array.description('overflow pills options')
};
OverflowPill.propTypes = props;
var DSOverflowPillWithSchema = describe(OverflowPill);
DSOverflowPillWithSchema.propTypes = props;

export { DSOverflowPillWithSchema, OverflowPill };
//# sourceMappingURL=OverflowPill.js.map
